import actionRequest from './actionRequest.json'
import actions from './actions.json'
import alert from './alert.json'
import asset from './asset.json'
import aurora from './aurora.json'
import breadcrumbs from './breadcrumbs.json'
import common from './common.json'
import device from './device.json'
import heater from './heater.json'
import installation from './installation.json'
import manufacturing from './manufacturing.json'
import sms from './sms.json'
import validation from './validation.json'
import valve from './valve.json'
import ruuvitag from './ruuvitag.json'
import powerSupply from './powerSupply.json'
import graph from './graph.json'
import generator from './generator.json'
import catalogProduct from './catalogProduct.json'
import sensor from './sensor.json'
import automation from './automation.json'
import { TranslationResource } from '../../i18n'

const FR_TRANSLATION_RESOURCE = {
  actionRequest,
  actions,
  automation,
  alert,
  asset,
  aurora,
  breadcrumbs,
  catalogProduct,
  graph,
  generator,
  common,
  device,
  heater,
  installation,
  manufacturing,
  powerSupply,
  ruuvitag,
  sms,
  sensor,
  validation,
  valve
} satisfies TranslationResource

export default FR_TRANSLATION_RESOURCE
